import React, { useState } from 'react'
import { Panel, Row, Message } from 'rsuite'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../utils/loading'
import CheckboxRowForm from '../../components/forms/checkboxRowForm/CheckboxRowForm'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import EditButton from '../../components/buttons/editButton/EditButton'
import { saveAttorneyType } from '../../redux/actions/attorney'
import ConfirmWidget from '../confirm/ConfirmWidget'

export default function AttorneyType({ schema: _schema, showCommandButton, updatePerson }) {
  const formAttorney = useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [isLoading, setIsLoading] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [error, setError] = useState(false)
  const [isShowConfirmModal, setIsShowConfirmModal] = useState(false)

  const handleSaveAttorneyType = async (request) => {
    startLoading()
    setIsLoading(true)
    setError()
    try {
      const response = await saveAttorneyType(projectId, request)
      setIsEdit(false)
      setFormSchema((state) => {
        return {
          ...state,
          optionSelected: request.value,
        }
      })
      updatePerson(response.model.attorneyPerson)
    } catch (e) {
      setError('เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ')
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = () => {
    setIsShowConfirmModal(true)
  }

  const handleOnConfirmModal = (data) => {
    let optionSelected = formSchema.options.map((item) => {
      if (data[item.name]) {
        return item.value
      }
      return null
    })
    optionSelected = optionSelected.filter((item) => item !== null)
    const request = {
      value: optionSelected,
    }
    setIsShowConfirmModal(false)
    handleSaveAttorneyType(request)
  }

  return (
    <>
      <Panel header={formSchema?.header} collapsible defaultExpanded bordered shaded>
        {isEdit && showCommandButton ? (
          <CheckboxRowForm
            schema={formSchema}
            Controller={Controller}
            {...formAttorney}
          ></CheckboxRowForm>
        ) : (
          <div>
            {formSchema?.optionSelected.length === 0 ? (
              <span>- ไม่ได้ระบุ -</span>
            ) : (
              <ul>
                {formSchema?.optionSelected.map((item) => {
                  const _selected = formSchema?.options.filter((i) => i.value == item)
                  const _label = _selected.length ? _selected[0].label : ''
                  return (
                    <li key={item} style={{ marginBottom: 8 }}>
                      {_label}
                    </li>
                  )
                })}
              </ul>
            )}
          </div>
        )}

        {showCommandButton && (
          <>
            <hr />
            {isEdit ? (
              <>
                {error && (
                  <Row style={{ marginBottom: 10 }}>
                    <Message
                      showIcon
                      type="error"
                      description={
                        'เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ'
                      }
                    />
                  </Row>
                )}
                <SaveButton onClick={formAttorney.handleSubmit(onSubmit)} disabled={isLoading} />
                <CancelButton onClick={() => setIsEdit(false)} />
              </>
            ) : (
              <EditButton onClick={() => setIsEdit(true)}>แก้ไขการมอบอำนาจ</EditButton>
            )}
          </>
        )}
        <ConfirmWidget
          title={`ยืนยันการแก้ไขผู้มอบอำนาจ`}
          show={isShowConfirmModal}
          detail={`ยืนยันการแก้ไขผู้มอบอำนาจ`}
          onCancle={() => setIsShowConfirmModal(false)}
          onConfirm={formAttorney.handleSubmit(handleOnConfirmModal)}
        />
      </Panel>
    </>
  )
}
